import React from 'react'

export default function Welcome() {

    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fafafa',
            padding: '2rem'
        }}>
            <img
                src="/icons/NoChat.png"
                alt="No Chat"
                style={{
                    maxWidth: '280px',
                    marginBottom: '2rem',
                    opacity: 0.9
                }}
            />
            <h2 style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                fontSize: '28px',
                color: '#3b362a',
                marginBottom: '0.5rem'
            }}>
                Welcome!
            </h2>
            <h6 style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: '16px',
                color: '#757575',
                margin: 0
            }}>
                Select a patient to start the conversation
            </h6>
        </div>
    )
}